var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minisite-audio-list",style:(_vm.getListStyle)},[(_vm.data.style.templateId === '00')?_c('template-00',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }